import {ArrowLeft, Package, Save} from 'lucide-react'
import {EditablePreviewImages, IconEditor} from './MediaFields'

export type EditingPlugin = {
  id: string
  name: string
  author: string
  category: string
  group: string
  runtime: string
  summary: string
  description: string
  status: string
  billingType: string
  icon: string
  previews: string
}

type CategoryOption = {
  value: string
  label: string
}

export function PluginEditorPage({
  plugin,
  categoryOptions,
  onChange,
  onCancel,
  onSave,
}: {
  plugin: EditingPlugin
  categoryOptions: CategoryOption[]
  onChange: (plugin: EditingPlugin) => void
  onCancel: () => void
  onSave: () => void
}) {
  return (
    <>
      <div className="page-heading">
        <div>
          <span className="eyebrow">Plugin profile</span>
          <h2>{plugin.id ? '编辑插件' : '新建插件'}</h2>
          <p>保存插件基础信息，版本包仍通过上传插件包维护。</p>
        </div>
        <div className="page-actions">
          <button className="secondary" onClick={onCancel}><ArrowLeft size={15} /> 返回列表</button>
          <button className="primary" onClick={onSave}><Save size={15} /> 保存插件</button>
        </div>
      </div>
      <div className="editor-layout">
        <aside className="editor-summary panel">
          <span className="editor-summary-label">市场卡片预览</span>
          <div className="editor-preview-icon">{plugin.icon ? <img src={plugin.icon} alt="" /> : <Package size={28} />}</div>
          <h3>{plugin.name || '未命名插件'}</h3>
          <code>{plugin.id || 'plugin-id'}</code>
          <p>{plugin.summary || '填写一句简洁的插件介绍，帮助用户快速理解它的价值。'}</p>
          <div className="editor-preview-meta"><span>{categoryOptions.find((item) => item.value === plugin.group)?.label || '实用工具'}</span><span>{plugin.billingType === 'paid' ? '收费' : '免费'}</span></div>
        </aside>
        <section className="editor-main">
          <div className="panel editor-section">
            <div className="editor-section-head"><span>01</span><div><h3>身份信息</h3><p>定义插件的唯一标识和展示名称。</p></div></div>
            <div className="form-grid editor-form">
              <label><span>插件 ID</span><input value={plugin.id} onChange={(event) => onChange({...plugin, id: event.target.value})} placeholder="plugin id" /></label>
              <label><span>插件名称</span><input value={plugin.name} onChange={(event) => onChange({...plugin, name: event.target.value})} placeholder="插件名称" /></label>
              <label><span>作者</span><input value={plugin.author} onChange={(event) => onChange({...plugin, author: event.target.value})} placeholder="官方" /></label>
              <label className="media-field"><span>插件 Icon</span><IconEditor value={plugin.icon} onChange={(icon) => onChange({...plugin, icon})} /></label>
            </div>
          </div>
          <div className="panel editor-section">
            <div className="editor-section-head"><span>02</span><div><h3>发布设置</h3><p>配置运行模式、市场分组和商业状态。</p></div></div>
            <div className="form-grid editor-form three-columns">
              <label><span>Runtime</span><select value={plugin.runtime} onChange={(event) => onChange({...plugin, runtime: event.target.value})}><option value="process">process</option><option value="declarative">declarative</option><option value="webhook">webhook</option><option value="builtin">builtin</option><option value="go-plugin">go-plugin</option></select></label>
              <label><span>插件分组</span><select value={plugin.group} onChange={(event) => onChange({...plugin, group: event.target.value, category: event.target.value})}>{categoryOptions.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}</select></label>
              <label><span>状态</span><select value={plugin.status} onChange={(event) => onChange({...plugin, status: event.target.value})}><option value="draft">草稿</option><option value="listed">已上架</option><option value="unlisted">已下架</option></select></label>
              <label><span>收费方式</span><select value={plugin.billingType} onChange={(event) => onChange({...plugin, billingType: event.target.value})}><option value="free">免费</option><option value="paid">收费</option></select></label>
            </div>
          </div>
          <div className="panel editor-section">
            <div className="editor-section-head"><span>03</span><div><h3>市场内容</h3><p>完善商城卡片与详情页的内容。</p></div></div>
            <div className="form-grid editor-form">
              <label className="wide"><span>插件简介</span><textarea value={plugin.summary} onChange={(event) => onChange({...plugin, summary: event.target.value})} placeholder="显示在商城卡片名称下方" /></label>
              <label className="wide"><span>插件介绍</span><textarea value={plugin.description} onChange={(event) => onChange({...plugin, description: event.target.value})} placeholder="显示在商城详情弹窗中" /></label>
              <label className="wide media-field"><span>功能预览图</span><EditablePreviewImages value={plugin.previews} onChange={(previews) => onChange({...plugin, previews})} /></label>
            </div>
          </div>
          <div className="editor-footer"><button className="secondary" onClick={onCancel}>取消</button><button className="primary" onClick={onSave}><Save size={15} /> 保存插件</button></div>
        </section>
      </div>
    </>
  )
}
